import { assertNever } from "@impero-com/common/utils/obj";
import memoizeOne from "memoize-one";

import { ControlAssignmentData } from "utils/controls/assignmentUtils";
import { Guid } from "utils/guid";

import { SodValidationIssues, validateSod } from "./segregationOfDuties";

export type AssignmentIdToSodIssues = Record<Guid, SodValidationIssues>;

export const getAssignmentIdToSodIssues = memoizeOne(
    (assignmentData: ControlAssignmentData) => {
        if (!assignmentData.segregationOfDutiesEnabled) {
            return {};
        }

        const assignmentIdToSodIssues: AssignmentIdToSodIssues = {};

        for (const [assignmentId, assignee] of Object.entries(
            assignmentData.initialAssignment
        )) {
            const secondReviewer =
                assignmentData.subsequentAssignments[1][assignmentId];
            const firstReviewerKind = secondReviewer
                ? assignmentData.subsequentAssignments[0][assignmentId]
                : undefined;
            const finalReviewerKind = secondReviewer
                ? secondReviewer
                : assignmentData.subsequentAssignments[0][assignmentId];

            if (finalReviewerKind) {
                const validationResult = validateSod(
                    assignee,
                    finalReviewerKind,
                    firstReviewerKind
                );

                switch (validationResult.type) {
                    case "SodIssues":
                        assignmentIdToSodIssues[assignmentId] =
                            validationResult;
                        break;
                    case "NoSodIssues":
                        break;
                    default:
                        assertNever(validationResult);
                }
            }
        }
        return assignmentIdToSodIssues;
    }
);
